export default __webpack_public_path__ + "static/media/instasites.05631be3.svg";